import metadata from 'libphonenumber-js/min/metadata';

const GEO_CACHE_KEY = 'phone_input_geo_country';

export function isSupportedCountry(code) {
  if (!code) return false;
  const normalized = code.toUpperCase();
  return Boolean(metadata.countries?.[normalized]);
}

export async function fetchIpCountry({ signal } = {}) {
  const res = await fetch('https://ipapi.co/json/', { signal });
  if (!res.ok) throw new Error('geo fetch failed');
  const data = await res.json();
  const country = typeof data?.country === 'string' ? data.country.toUpperCase() : undefined;
  return isSupportedCountry(country) ? country : undefined;
}

async function safeFetchIpCountry(signal) {
  try {
    return await fetchIpCountry({ signal });
  } catch (_error) {
    return undefined;
  }
}

export function getLocaleCountry() {
  const locale = typeof navigator !== 'undefined' ? navigator.languages?.[0] || navigator.language : undefined;
  const localeCountry = locale?.split('-')[1]?.toUpperCase();
  return isSupportedCountry(localeCountry) ? localeCountry : undefined;
}

export async function detectCountryWithCache() {
  if (typeof window === 'undefined') return undefined;
  const cached = window.sessionStorage?.getItem(GEO_CACHE_KEY);
  if (cached && isSupportedCountry(cached)) return cached;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 2500);

  try {
    const country = await safeFetchIpCountry(controller.signal);
    if (country) {
      window.sessionStorage?.setItem(GEO_CACHE_KEY, country);
      return country;
    }
  } finally {
    clearTimeout(timer);
  }

  return undefined;
}
